import { forwardRef } from 'react';
import TableBaseButton from './TableBaseButton';

interface CancelButtonProps {
  onClick: () => void;
  ref?: React.Ref<HTMLButtonElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const CancelButton = forwardRef<HTMLButtonElement, CancelButtonProps>(
  ({ onClick, onKeyDown }, ref) => {
    return (
      <TableBaseButton
        onClick={onClick}
        variant="secondary"
        buttonText="キャンセル"
        ref={ref}
        onKeyDown={onKeyDown}
      />
    );
  }
);

CancelButton.displayName = 'CancelButton';
export default CancelButton;
